import p5Types from 'p5';

type EventHandler = (e: any) => void;

export const registerMouseEventHandlers = (
  p5: p5Types,
  onTouchStarted: EventHandler,
  onTouchMoved: EventHandler,
  onTouchEnded: EventHandler,
  onScroll: EventHandler,
) => {
  p5.mouseDragged = onTouchMoved;
  p5.touchStarted = onTouchStarted;
  p5.touchMoved = onTouchMoved;
  p5.touchEnded = onTouchEnded;
  p5.mouseWheel = onScroll;
};

export const teardownMouseEventHandlers = (p5: p5Types) => {
  p5.touchStarted = () => {};
  p5.touchMoved = () => {};
  p5.touchEnded = () => {};
  p5.mouseWheel = () => {};
};
